import { Box, Typography } from '@mui/joy'
import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { viewerModel } from '~/entities/viewer'
import {
  LocaleForm,
  LoginForm,
  loginFormModel,
} from '~/features/Auth/by-credentials'
import { Button } from '~/shared/ui/Buttons'
import { Container } from '~/shared/ui/Layout'
import { LocaleWrapper } from './styled'

export function LoginPage() {
  const { t } = useTranslation()

  const authenticated = viewerModel.useAuthenticated()
  const isLoginPending = useStore(loginFormModel.loginFx.pending)
  const isMePending = useStore(loginFormModel.getUserMeFx.pending)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <Container width='480px'>
        {authenticated && !isLoginPending && !isMePending ? (
          <>
            <Typography textAlign='center'>
              {t('alert.already authorized')}
            </Typography>
            <br />
            <Button size='lg' onClick={() => viewerModel.signOut()}>
              {t('button.logout')}
            </Button>
          </>
        ) : (
          <>
            <Box sx={{ position: 'relative' }}>
              <Typography
                fontSize={18}
                fontWeight={600}
                textAlign='center'
                sx={{ mb: '40px' }}
              >
                {t('button.login')}
              </Typography>
              <LocaleWrapper>
                <LocaleForm />
              </LocaleWrapper>
            </Box>
            <LoginForm />
          </>
        )}
      </Container>
    </Box>
  )
}
